import './style.scss';
import onDocumentReady from 'shared/onDocumentReady';
import { createApp } from '~/vue/createApp';
import SiteHeader from './SiteHeader.vue';

/**
 * One of the five site wide mounts, and the shape they all had: a `new Vue({el, render})`
 * root whose whole job was to render one component into a placeholder.
 *
 * `createApp(Component).mount(el)` is the vue 3 spelling of exactly that, and it renders the
 * same dom - compat's mount already empties the container and renders inside it rather than
 * replacing it, as vue 2 did. The wrapper root goes with the conversion: the component is the
 * root now, so the `name` that only ever showed up in devtools has nothing to name.
 *
 * Built through vue/createApp rather than vue's own, so these get the store and the router
 * that a `new Vue()` root never had. None of the five needs either today.
 */
function initVue() {
    const el = document.getElementById('site-header-component');
    if (!el) {
        return;
    }
    createApp(SiteHeader).mount(el);
}

onDocumentReady(initVue);
